export default "__VITE_ASSET__DheGzIWr__"